<template>
  <div class="login container">
    <ValidationObserver v-slot="{handleSubmit}" ref="login" tag="form" @submit.prevent>
      <img src="@/assets/logo.png" class="logo" />
      <NText
          name="email"
          type="email"
          v-model="email"
          rules="required|email"
          designType="line"
          borderColor="#004196"
          textColor="black"
          placeholder="Email address"
          :showIcons="false" >
        </NText>
        <NPassword
          name="password"
          type="password"
          v-model="password"
          rules="required"
          designType="line"
          textColor="black"
          borderColor="#004196"
          placeholder="Password"
          revealColor="#004196"
          :showIcons="false">
        </NPassword>
        <a class="cursor-pointer"  @click="$router.push({name: 'reset_password'})">Forgotten password?</a>
        <button class="red cursor-pointer" :class="{'disabled' : loading}" @click="handleSubmit(login)">Login</button>
        <transition name="fade">
          <span v-if="error">{{error}}</span>
        </transition>
    </ValidationObserver>
  </div>
</template>

<script>
import { LOGIN, GET_MODULE } from '@/store/api'
import { NText, NPassword } from '@team-uep/n-inputs'
import { mapGetters } from 'vuex'
export default {
  name: 'Login',
  data () {
    return {
      email: '',
      password: '',
      error: null,
      loading: false
    }
  },
  components: {
    NText,
    NPassword
  },
  computed: {
    ...mapGetters({
      requestedId: 'modules/requestedId'
    })
  },
  methods: {
    login() {
      this.error = null
      this.loading = true
      this.$apollo.mutate({
        mutation: LOGIN,
        variables: {
          input: {email: this.email, password: this.password}
        },
        update: (cache, { data }) => {
          if (data.errors) {
            this.error = "Please verify your email and/or password"
          } else {
            if (data.loginUser.admin) {
              this.error = "Please verify your email and/or password"
            } else {
              this.$store.commit('user/set', data.loginUser)
              if (this.requestedId) {
                this.$apollo.query({
                    query: GET_MODULE(this.requestedId),
                  })
                  .then((result) => {
                    this.loading = false
                    if (result.errors && result.errors[0].message === 'login required') {
                      this.$router.push({name: 'login'})
                    } else {
                      this.$store.commit('modules/SELECT_MODULE', result.data.module)
                      this.$router.push({ name: 'details', query: { id: result.data.module.id }}) 
                    }
                  })
              } else {
                this.$router.push({name: 'home'})
              }
            }
          }
          this.loading = false
        }
      })
      .catch(() => {
        this.error = "Please verify your email and/or password"
        this.loading = false
      })
    }
  },
  watch: {
    email () {
      this.error = null
    }, 
    password () {
      this.error = null
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "@/styles";
  .login {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-grow: 1;
    a.cursor-pointer, .cursor-pointer {
      cursor: pointer;
    }
  }

button {
  cursor: pointer;
  text-transform: uppercase;
}

</style>